module.exports = __webpack_public_path__ + "img/zhuhai-1.f364f13a.jpg";